import { createSlice } from "@reduxjs/toolkit";
import { api } from "../../services/rtk/api.js";

const initialState = {
  profile: null,
  isLoading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUserError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get current user
      .addMatcher(api.endpoints.getCurrentUser.matchPending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(
        api.endpoints.getCurrentUser.matchFulfilled,
        (state, { payload }) => {
          state.profile = payload;
          state.isLoading = false;
          state.error = null;
        }
      )
      .addMatcher(
        api.endpoints.getCurrentUser.matchRejected,
        (state, { payload }) => {
          state.isLoading = false;
          state.error = payload?.data || "Failed to fetch user profile";
        }
      )

      // Update profile
      .addMatcher(api.endpoints.updateProfile.matchPending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(
        api.endpoints.updateProfile.matchFulfilled,
        (state, { payload }) => {
          state.profile = { ...state.profile, ...payload };
          state.isLoading = false;
          state.error = null;
        }
      )
      .addMatcher(
        api.endpoints.updateProfile.matchRejected,
        (state, { payload }) => {
          state.isLoading = false;
          state.error = payload?.data || "Failed to update profile";
        }
      );
  },
});

export const { clearUserError } = userSlice.actions;
export default userSlice.reducer;
